module.exports = __webpack_public_path__ + "img/api-logo-cardno.9faba7de.png";